






























































































































































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import StateComponent from "@/mixins/StateComponent";
import { YFC } from "@/utils/constants";
import { Cart, CartItem } from 'yf-commerce-model-ui-lib';
import Picture from '@/components/picture/Picture.vue';

@Component({
	components: {
		'yfc-picture': Picture
	}
})
export default class CartDetail extends mixins(StateComponent) {

	loading = false;

	constructor() {
		super();
	}

	get showvat(): boolean {
		return (process.env.VUE_APP_SHOWVAT) === 'true';
	}

	get checkoutUrl(): string {
		if (this.state.user || (this.state.shopConf && this.state.shopConf.shopguest)) {
			return process.env.VUE_APP_CHECKOUT_URL as string;
		}
		return `${process.env.VUE_APP_LOGIN_PATH}?redirect=true`;
	}

	get productPath(): string {
		return process.env.VUE_APP_PRODUCT_PATH as string;
	}

	get cart(): Cart | undefined {
		return this.state.cart;
	}

	get imgPlaceholder(): string {
		return require('@/assets/images/product/placeholder.jpg')
	}

	removeItem(item: CartItem) {
		this.loading = true;
		this.cartService.remove(item).then((cart) => {
			this.$oruga.notification.open({
				message: this.$t('cart-remove-success'),
				position: 'top-right',
				variant: 'success'
			})
			this.sendEvent(YFC.EVENT_CART, cart);
		}).finally(() => (this.loading = false));
	}

	incrementItem(item: CartItem) {
		this.loading = true;
		const qty = item.qty + (item.multipleqty || 1);
		this.cartService.updateQuantity(item, qty).then((cart) => {
			this.sendEvent(YFC.EVENT_CART, cart);
		}).finally(() => (this.loading = false));
	}

	decrementItem(item: CartItem) {
		if (item.qty > 1) {
			this.loading = true;
			const qty = item.qty - (item.multipleqty || 1);
			this.cartService.updateQuantity(item, qty).then((cart) => {
				this.sendEvent(YFC.EVENT_CART, cart);
			}).finally(() => (this.loading = false));
		}
	}
}
